import React, { useState, useEffect } from "react";
import SkeletonLoader from "./SkeletonLoader";

const LoadImage = ({ record }) => {
  const [content, setContent] = useState(null);
  const [contentType, setContentType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log("record.map_url", record.map_url);
    if (!record?.map_url) return; // Ensures no operation if record or map_url is undefined

    const fetchData = async () => {
      setIsLoading(true); // Start loading
      try {
        const response = await fetch(record.map_url);
        console.log("response", response);
        const blob = await response.blob();
        const type = blob.type;
        setContentType(type);
        if (type === "application/pdf") {
          setContent(record.map_url);
        } else {
          const objectURL = URL.createObjectURL(blob);
          setContent(objectURL);
        }
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false); // End loading
    };

    fetchData();
  }, [record?.map_url]); // Dependency on map_url only to prevent unnecessary reruns

  if (isLoading) {
    return <SkeletonLoader title="Image" />;
  }

  if (!content) return <SkeletonLoader title="No Map" />; // Render empty div if no content

  return (
    <div
      id="zone-map-div"
      style={{
        display: "flex",
        flexDirection: "column",
        fontSize: "0.9em",
        fontWeight: "500",
        fontFamily: "verdana",
        width: "100%",
        maxWidth: "75vw",
        overflow: "hidden",
      }}
    >
      {contentType === "application/pdf" ? (
        <iframe
          src={content}
          style={{ width: "100%", height: "1000px", border: "none" }}
        />
      ) : (
        <img
          src={content}
          alt="Zone Map"
          style={{ width: "100%", height: "auto" }}
        />
      )}
    </div>
  );
};

export default LoadImage;
